// DEV-ONLY fallback (REMOVE BEFORE MERGE) — local DBs often have an empty
// `ItemTagStatistic.active` table, which strips every suggested tag in the
// backend before the prop reaches us. This keeps the Tags filter populated
// while building the UI. Guarded by NODE_ENV so webpack tree-shakes it from
// production builds.
const DEV_FALLBACK_TAGS = [
  'cars', 'animals', 'characters', 'weapons', 'furniture',
  'architecture', 'vehicles', 'plants', 'food', 'accessories',
  'robots', 'anatomy',
]

export const withDevFallbackTags = (tags) => (
  tags.length === 0 && process.env.NODE_ENV === 'development' ? DEV_FALLBACK_TAGS : tags
)

export default DEV_FALLBACK_TAGS
